import {Component, ViewChild} from '@angular/core'
import {CompetitionService} from 'app/services/competition.service'
import {SharepointService} from 'app/services/sharepoint.service'

@Component({
    selector: 'app-stadium-background',
    templateUrl: './stadium-background.component.html',
    styleUrls: ['./stadium-background.component.scss']
})
export class StadiumBackgroundComponent {

    file: File
    @ViewChild('fileInput') fileInput: any

    constructor(private competitionService: CompetitionService,
        private sharepointService: SharepointService,
    ) {}

    onImgChange(event): void {
        this.file = event.file
        this.uploadBackground()
    }

    onChange(event) {
        if (event.target.files && event.target.files.length === 1 && event.target.files[0].type.includes('image')) {
            this.file = event.target.files[0]
            this.uploadBackground()
        }
    }

    private uploadBackground() {
        const competition = this.competitionService.getCompetitionSelected()
        competition.stadiumFile = this.file.name
        this.competitionService.update(competition).subscribe(res => {
            this.sharepointService.upSharepointFile(Object.assign(res.assetStadium, {
                mimeType: 'image/*',
            }), this.file).subscribe((sharepointResult) => {
                location.reload()
            })
        })
    }
}
